import React, { useCallback, useMemo } from 'react'
import { Form } from 'react-final-form'
import { FormattedMessage } from 'react-intl'
import { injectMessages } from '@/logic/translation/utils'
import { useRegionItemDropdownOptions } from '@/logic/userRegion'
import { Button } from '../../../..'
import { Dropdown } from '../../../../fields'
import messages from './messages.json'
import type { IUserRegionChooserFormValues, IUserRegionChooserModalProps } from './types'
import './styles.scss'

injectMessages(messages)

const UserRegionChooserModal: React.FC<IUserRegionChooserModalProps> = ({ options }) => {
  const { value, onInput } = options
  const { regionOptions } = useRegionItemDropdownOptions()

  const initialValues: IUserRegionChooserFormValues = useMemo(
    () => ({
      region: value,
    }),
    [value],
  )

  const onSubmit = useCallback(
    ({ region }: IUserRegionChooserFormValues) => {
      if (region) onInput(region)
    },
    [onInput],
  )

  return (
    <div className="user-region-chooser-modal">
      <FormattedMessage tagName="h3" id="userRegionChooserModal.title" />
      <Form<IUserRegionChooserFormValues> onSubmit={onSubmit} initialValues={initialValues}>
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Dropdown
              isSearchable
              name="region"
              options={regionOptions}
              labelId="userRegionChooserModal.placeholder"
              className="space-holder16"
            />
            <Button
              type="submit"
              className="space-holder-top32"
              textId="userRegionChooserModal.button"
              modifiers={['full-width', 'green']}
            />
          </form>
        )}
      </Form>
    </div>
  )
}

export default UserRegionChooserModal
